import { put } from "redux-saga/effects"
import { getCookieValue } from "../utils/cookies"
import {
  getConversions,
  getMetaConversions,
  getRedditConversions,
} from "../actions"
import { withinLast7Days } from "../utils/dates"
import { isLive } from "../utils/project"

const META_TRACKING_BACKERVOICE_ONLY = "backervoice_only"
const META_TRACKING_KICKSTARTER_AND_BACKERVOICE = "kickstarter_and_backervoice"

const FIRE_META_CONVERSIONS = [
  META_TRACKING_BACKERVOICE_ONLY,
  META_TRACKING_KICKSTARTER_AND_BACKERVOICE,
]

export default function* handleConversions({ payload }) {
  const {
    uuid,
    meta_tracking_configuration,
    project_status,
    project_end_date,
    pixel_fired_at,
  } = payload.data

  if (pixel_fired_at) {
    console.log("Pixel already fired at:", pixel_fired_at)
    return
  }

  if (isLive(project_status) || withinLast7Days(project_end_date)) {
    yield put(getConversions(uuid))

    yield put(getRedditConversions(uuid))

    if (FIRE_META_CONVERSIONS.includes(meta_tracking_configuration)) {
      yield put(
        getMetaConversions(uuid, {
          event_source_url: window.location.href,
          fbp: getCookieValue("_fbp"),
          fbc: getCookieValue("_fbc"),
        })
      )
    }
  }
}
